// Bazaarvoice's rating summary scrolls to a target in its own shadow root, landing the user mid-widget under the fixed header.

const GAP = 24;

export type ReviewsTarget = HTMLElement;

const RATING_BUTTON = '[data-bv-show="rating_summary"] .bv_main_rating_button';
// Only sections/rich-text.liquid emits this class, so a neighbouring section that merely carries an h2 is never taken for the "Reviews" heading.
const REVIEWS_HEADING = '.rich-text__heading';

// The "Reviews" heading is its own rich-text section above the app block.
function reviewsTarget(): HTMLElement | null {
  const section = document
    .querySelector<HTMLElement>('[data-bv-show="reviews"]')
    ?.closest<HTMLElement>('.shopify-section');
  if (!section) return null;

  const previous = section.previousElementSibling;
  return previous?.querySelector(REVIEWS_HEADING) ? (previous as HTMLElement) : section;
}

// --header-height is unusable: it measures .section-header, which collapses to 0.
function clearance(): number {
  const header = document.querySelector<HTMLElement>('.header-wrapper');
  if (!header) return 0;
  // top is 'auto' if the header is ever unpinned, which parses to NaN.
  const top = parseFloat(getComputedStyle(header).top) || 0;
  return top + header.offsetHeight;
}

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target as Element).closest?.(RATING_BUTTON)) return;

    const target = reviewsTarget();
    if (!target) return;

    // bazaarvoice-reviews-retire hid the heading, so there is nothing left to scroll to.
    if (getComputedStyle(target).visibility === 'hidden') return;

    // Stops Bazaarvoice's own handler, and with it their click tracking on this control.
    event.stopPropagation();
    event.preventDefault();

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Set explicitly so this wins over the global html { scroll-behavior: smooth }.
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - clearance() - GAP,
      behavior: reducedMotion ? 'auto' : 'smooth',
    });

    // Otherwise focus stays on the rating button and the next Tab returns to the page top.
    const heading = target.querySelector<HTMLElement>(REVIEWS_HEADING) ?? target;
    heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
  },
  true,
);
